import { createContext, useContext } from "react";

import { DefaultContext } from "constants/context/context";

import { RUseCommon } from "./useCommon";

export const CommonContext = createContext(DefaultContext);
export const useCommonContext = () => useContext<RUseCommon>(CommonContext);
//? use  this  👆 for global context, because it is already typed
